import type { IAccountEvent } from "@apis/accounts/types"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/ui/tooltip"
import { Button } from "@components/ui/button"
import { useDrawer } from "@contexts/DrawerContext"
import { formatDate, timeAgo } from "@utils/formatters"
import { Conversations } from "@components/AccountNew/Conversations/Conversations"
import type { IBaseEvent } from "@commonTypes/events"
import { LucideIcon } from "@components/LucideIcon/LucideIcon"

type TEventItemProps = {
  event: IAccountEvent | IBaseEvent
}

export const EventItem = ({ event }: TEventItemProps) => {
  const formattedDate = formatDate(event.date, "M/d/yyyy h:mm a")

  const { openDrawer } = useDrawer()

  return (
    <div className="tw:flex tw:border-b tw:border-gray-200 tw:py-4 tw:hover:bg-gray-100">
      <div className="tw:w-2/12 tw:text-center">
        <Tooltip key={event.date}>
          <TooltipTrigger>
            <LucideIcon
              name={event.icon}
              className="tw:inline-block tw:h-6 tw:w-6 tw:translate-y-1 tw:transform tw:text-muted-foreground"
            />
            <div className="tw:mt-1 tw:text-xs tw:text-muted-foreground">
              {timeAgo(event.date)}
            </div>
          </TooltipTrigger>
          <TooltipContent side="bottom">
            <span>{formattedDate}</span>
          </TooltipContent>
        </Tooltip>
      </div>

      <div className="tw:w-10/12">
        <div className="tw:text-sm tw:font-medium tw:text-foreground">
          {event.title}
        </div>
        <div
          className="tw:mt-1 tw:text-xs tw:whitespace-pre-wrap tw:text-gray-600"
          dangerouslySetInnerHTML={{ __html: event.description }}
        />
        {event.type === "Gladly" && (
          <Button
            variant="default"
            className="mt-2"
            size="sm"
            onClick={() =>
              openDrawer(
                <Conversations
                  conversationId={event.conversation_id as string}
                  xref_id={event.xref_id as string}
                />,
                "Gladly Conversation",
              )
            }
          >
            View Conversation
          </Button>
        )}
      </div>
    </div>
  )
}
